const homeEn = {
  "home.formSections.phone": "PHONE",
  "home.formSections.email": "EMAIL",
  "home.formSections.checking": "CHECKING",
  "home.formSections.savings": "SAVINGS",
  "home.formSections.debit": "DEBIT",
  "home.step.first": "Choose final country",
  "home.step.second": "Choose payment method",
  "home.formValidate.invalidName": "Invalid Name",
  "home.formValidate.selectBank": "Please select a bank",
  "home.formValidate.selectDocumentType": "Please select a document type",
  "home.formValidate.invalidId": "Invalid Id",
  "home.formValidate.selectAccountType": "Please select a account type",
  "home.formValidate.invalidAccount": "Invalid Account",
  "home.formValidate.invalidEmailAddress": "Invalid e-mail addresss",
  "home.formValidate.inputEmail": "Please input your e-mail",
  "home.formValidate.inputCellphone": "Please input a cellphone",
  "home.formValidate.invalidCellphone": "Invalid Cellphone",
  "home.formValidate.inputCpfOrCnpj": "Please input your cpf or cnpj",
  "home.formValidate.invalidCpfOrCnpj": "Invalid CPF/CNPJ",
  "home.formValidate.selectCountry": "Please select a country",
  "home.formValidate.inconsistent": "The accounts are inconsistent",
  "home.formValidate.selectKeyType": "Please select a key type",
  "home.formValidate.fillPixKey": "Please fill in the Pix Key",
  "home.formValidate.invalidPixKey": "Invalid Pix Key",
  "home.formValidate.inputAccountNumber": "Please input your account number",
  "home.formValidate.accountDigitLen12":
    "The account digit field should be 1 to 2 characters",
  "home.formValidate.inputAccountDigit": "Please input your account digit",
  "home.formValidate.accountDigitLen15":
    "The account digit field should be 1 to 5 characters",
  "home.formValidate.inputBankBranch": "Please input your bank branch",
  "home.formValidate.nameLen5_100": "name character length 5-100",
  "home.formValidate.name": "Name",
  "home.formValidate.keyType": "Key Type",
  "home.formValidate.pixType": "Pix Type",
  "home.formValidate.email": "E-mail",
  "home.formValidate.cellphone": "Cellphone",
  "home.formValidate.account": "Account",
  "home.formValidate.bank": "Bank",
  "home.formValidate.accountType": "Account Type",
  "home.formValidate.accountNumber": "Account Number",
  "home.formValidate.accountDigit": "Account digit",
  "home.formValidate.bankBranch": "Bank branch",
  "home.formValidate.bankDigit": "Bank digit",
  "home.formValidate.documentType": "Document type",
  "home.formValidate.documentId": "Id",
  "home.formValidate.paypalCountry": "Paypal country",
  "home.formValidate.paypalAccount": "Paypal account",
  "home.formValidate.rePaypalAccount": "Re-enter Paypal account",
  "home.formValidate.selectPaymentBank": "Please choose a payment bank",
};

const homeEs = {
  "home.formSections.phone": "TELEFONE",
  "home.formSections.email": "EMAIL",
  "home.formSections.checking": "VERIFICANDO",
  "home.formSections.savings": "AHORROS",
  "home.formSections.debit": "DÉBITO",
  "home.step.first": "Selecciona el país final",
  "home.step.second": "Escoge el método de pago",
  "home.formValidate.invalidName": "Nombre inválido",
  "home.formValidate.selectBank": "Seleccione un banco",
  "home.formValidate.selectDocumentType": "Seleccione un tipo de documento",
  "home.formValidate.invalidId": "Identificación inválido",
  "home.formValidate.selectAccountType": "Seleccione un tipo de cuenta",
  "home.formValidate.invalidAccount": "Cuenta no válida",
  "home.formValidate.invalidEmailAddress":
    "Dirección de correo electrónico inválida",
  "home.formValidate.inputEmail": "Por favor ingrese su correo electrónico",
  "home.formValidate.inputCellphone": "Ingrese un teléfono celular",
  "home.formValidate.invalidCellphone": "Teléfono celular inválido",
  "home.formValidate.inputCpfOrCnpj": "Ingrese su cpf o cnpj",
  "home.formValidate.invalidCpfOrCnpj": "Nombre CPF/CNPJ",
  "home.formValidate.selectCountry": "Por favor, selecione um país",
  "home.formValidate.inconsistent": "As contas são diferentes",
  "home.formValidate.selectKeyType": "Seleccione un tipo de clave",
  "home.formValidate.fillPixKey": "Por favor complete la clave Pix",
  "home.formValidate.invalidPixKey": "Clave de Pix no válida",
  "home.formValidate.inputAccountNumber": "Por favor ingrese su cuenta",
  "home.formValidate.accountDigitLen12":
    "El campo del dígito de la cuenta debe tener entre 1 y 2 caracteres",
  "home.formValidate.inputAccountDigit": "Ingrese el dígito de su cuenta",
  "home.formValidate.accountDigitLen15":
    "El campo del dígito de la cuenta debe tener entre 1 y 5 caracteres",
  "home.formValidate.inputBankBranch": "Por favor ingrese su sucursal bancaria",
  "home.formValidate.nameLen5_100": "longitud del carácter del nombre 5-100",
  "home.formValidate.name": "Nombre",
  "home.formValidate.keyType": "Tipo de clave",
  "home.formValidate.pixType": "Pix Type",
  "home.formValidate.email": "Correo electrónico",
  "home.formValidate.cellphone": "Teléfono móvil",
  "home.formValidate.account": "Cuenta",
  "home.formValidate.bank": "Banco",
  "home.formValidate.accountType": "Tipo de cuenta",
  "home.formValidate.accountNumber": "Número de cuenta",
  "home.formValidate.accountDigit": "Dígito de la cuenta",
  "home.formValidate.bankBranch": "Sucursal bancaria",
  "home.formValidate.bankDigit": "Dígito de la sucursal",
  "home.formValidate.documentType": "Tipo de Documento",
  "home.formValidate.documentId": "Identificación",
  "home.formValidate.paypalCountry": "País da conta Paypal",
  "home.formValidate.paypalAccount": "Conta Paypal",
  "home.formValidate.rePaypalAccount": "Reinsira a conta Paypal",
  "home.formValidate.selectPaymentBank": "Por favor elige un banco de pago",
};

const homePt = {
  "home.formSections.phone": "TELÉFONO",
  "home.formSections.email": "O EMAIL",
  "home.formSections.checking": "VERIFICANDO",
  "home.formSections.savings": "POUPANÇA",
  "home.formSections.debit": "DÉBITO",
  "home.step.first": "Escolha o país final",
  "home.step.second": "Escolha o método de pagamento",
  "home.formValidate.invalidName": "Nome inválido",
  "home.formValidate.selectBank": "Selecione um banco",
  "home.formValidate.selectDocumentType": "Selecione um tipo de documento",
  "home.formValidate.invalidId": "Identidade inválido",
  "home.formValidate.selectAccountType": "Selecione um tipo de conta",
  "home.formValidate.invalidAccount": "Conta inválida",
  "home.formValidate.invalidEmailAddress": "Por favor, preencha a chave Pix",
  "home.formValidate.inputEmail": "Por favor insira seu e-mail",
  "home.formValidate.inputCellphone": "Por favor insira um telefone celular",
  "home.formValidate.invalidCellphone": "Celular inválido",
  "home.formValidate.inputCpfOrCnpj": "Insira seu cpf ou cnpj",
  "home.formValidate.invalidCpfOrCnpj": "Nome CPF/CNPJ",
  "home.formValidate.selectCountry": "Por favor seleccione un país",
  "home.formValidate.inconsistent": "La cuentas son inconsistentes",
  "home.formValidate.selectKeyType": "Selecione um tipo de chave",
  "home.formValidate.fillPixKey": "Por favor, preencha a chave Pix",
  "home.formValidate.invalidPixKey": "Chave Pix inválida",
  "home.formValidate.inputAccountNumber": "Por favor insira sua conta",
  "home.formValidate.accountDigitLen12":
    "O campo de dígitos da conta deve ter de 1 a 2 caracteres",
  "home.formValidate.inputAccountDigit":
    "Por favor insira o dígito da sua conta",
  "home.formValidate.accountDigitLen15":
    "O campo de dígitos da conta deve ter de 1 a 5 caracteres",
  "home.formValidate.inputBankBranch": "Insira sua agência bancária",
  "home.formValidate.nameLen5_100": "nome comprimento de caracteres 5-100",
  "home.formValidate.name": "Nome",
  "home.formValidate.keyType": "Tipo de chave",
  "home.formValidate.pixType": "Chave Pix",
  "home.formValidate.email": "Email",
  "home.formValidate.cellphone": "Celular",
  "home.formValidate.account": "Conta",
  "home.formValidate.bank": "Banco",
  "home.formValidate.accountType": "Tipo de conta",
  "home.formValidate.accountNumber": "Número de conta",
  "home.formValidate.accountDigit": "Número da conta",
  "home.formValidate.bankBranch": "Agência bancária",
  "home.formValidate.bankDigit": "Dígito da filial",
  "home.formValidate.documentType": "Tipo de documento",
  "home.formValidate.documentId": "Identidade",
  "home.formValidate.paypalCountry": "País de la cuenta Paypal",
  "home.formValidate.paypalAccount": "Cuenta de Paypal",
  "home.formValidate.rePaypalAccount":
    "Vuelva a ingresar a la cuenta de Paypal",
  "home.formValidate.selectPaymentBank": "Escolha um banco de pagamento",
};

export { homeEn, homePt, homeEs };
